module.exports = __webpack_public_path__ + "static/media/2.e11a4590.jpg";